import filterConfig from "./filterConfig";
import tabConfig from "./tabConfig";
import mobileTabConfig from "./mobileTabConfig";
export default { filterConfig, tabConfig, mobileTabConfig };
